import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import SetupGuideCreateCampaignController from 'cio/pods/setup-guide/create-campaign/controller';
import SetupGuide from 'cio/models/setup-guide';
import EnvironmentService from 'cio/services/environment';
import Transition from '@ember/routing/-private/transition';

export default class SetupGuideCreateCampaign extends Route {
  @service environment!: EnvironmentService;

  crumb() {
    return {
      name: `Create your first ${this.environment.current.canIdentifyByEmail ? 'message' : 'campaign'}`,
      path: 'setup-guide.create-campaign',
    };
  }

  setupController(controller: SetupGuideCreateCampaignController, model: SetupGuide, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.fetchCampaignsTask.perform();
    controller.fetchNewslettersTask.perform();
  }

  resetController(controller: SetupGuideCreateCampaignController, isExiting: boolean) {
    if (isExiting) {
      controller.setDefaults();
    }
  }
}
